import React, { useEffect, useMemo, useState } from "react";
import { graphql } from "gatsby";
import Layout from "@herb/layouts";
import WrittenBy from "@herb/components/WrittenBy";
import ImageForArticlePage from "@herb/components/ImageForArticlePage";
import DescriptionForArticlePage from "@herb/components/DescriptionForArticlePage";
import BoldTextForArticlePage from "@herb/components/BoldTextForArticlePage";
import SectionHeading from "@herb/components/SectionHeading";
import Image from "@herb/components/Image";
import Button from "@herb/components/Button";
import PostVideo from "@herb/components/Post/PostVideo";
import ProductCard from "@herb/components/Cards/ProductCard";
import PostIframe from "@herb/components/Post/PostIframe";
import PostInstagram from "@herb/components/Post/PostInstagram";
import PostTweet from "@herb/components/Post/PostTweet";
import TopPickCard from "@herb/components/Cards/TopPickCard";
import JsonLd from "@herb/components/Schema/JsonLd";
import SEO from "@herb/components/seo";
import DisplayAd from "@herb/components/DisplayAd";
import { paths, deployUrl, categoryPath, displayAdsToHide, slugs as createSlug, isHiddenFromSite } from "@herb/utils";
import Container from "@herb/components/Container";
import ReactHtmlParser from "react-html-parser";
import { Link } from "@reach/router";
import getCategoryPath from "@herb/utils/categoryPath";
import CategoryTags from "@herb/components/CategoryTags";
import { generateRandom } from "@herb/utils/randomNumber";
import ArticleProduct from "@herb/components/ProductForArticlePage";
import LatestArticleLoadAlgolia from "@herb/components/Article/LatestArticleLoadAlgolia";
import LoadRandomProducts from "../../components/Article/LoadRandomProducts";
import LoadRandomBrands from "../../components/Article/LoadRandomBrands";
import Modal from "react-modal";
import { Icon, Box } from "@herb/ui";
import TrichomePopUpForm from "../../components/ILGMPopup";
import { Helmet } from "react-helmet";
import RelatedLinksCard from "@herb/components/Cards/RelatedLinksCard";
import SidebarBrandsAndProducts from "../../components/SidebarBrandsAndProducts";
import {
  // scriptCreate as aggleScript,
  includePAXScript
} from "@herb/utils/scripts";
import { track } from "@herb/utils/analytics";
import "./index.css";
import ArticleBreadCrumb from "../../components/ArticleBreadCrumb";

import ScavengerHuntPopUp from "../../components/ScavengerHuntPopUp/index";
import parentCategory from "../../utils/parentCategory";
import FeaturedProducts from "../../components/FeaturedProducts";
import ShareIcons from "../../components/shareIcons";
import FAQAccordion from "../../components/FAQAccordion";
import Disclaimer from "../../components/Disclaimer";
import ArticleTableOfContents from "../../components/ArticleTableofContents";
import CopyLinkButton from "../../components/CopyLinkButton";
import CustomTable from "../../components/CustomTable";
import AnnoucementBarHempBan from "../../components/AnnoucementBarHempBan";
const isBrowser = typeof window !== "undefined";

const LOGO_URL = `${deployUrl}/icons/icon-512x512.png`;

const PostTemplate = ({ data, pageContext }) => {
  const {
    publishDate,
    related_links: pagelinks,
    related_links_page,
    noindex,
    catPath,
    catName,
    catSlug
  } = pageContext;

  const ilgmSlugs = [
    "/learn/get-20-white-widow-seeds-for-the-price-of-10-at-ilgm/",
    "/news/culture/get-seeds-you-can-trust-with-expert-growing-advice-from-ilgm/",
    "/learn/get-20-white-widow-seeds-for-the-price-of-10-at-ilgm",
    "/news/culture/get-seeds-you-can-trust-with-expert-growing-advice-from-ilgm"
  ];

  const paxSlugs = [
    "/learn/how-to-boost-your-vaping-experience",
    "/learn/is-dry-herb-vaping-safe-dry-herb-vaporizer-health-risks",
    "/learn/comparing-pax-devices"
  ];

  const {
    wordpressWpPost: currentPost,
    newPosts: { nodes: latestArticles },
    sameCatPosts: { nodes: sameCatArticle = [] }
  } = data;
  // const stickyArticles = latestArticles.splice(0, 2);

  const showTableofContents =
    currentPost?.tableOfContents?.showTableOfContents || false;

  const [trichomeOpen, setTrichomeOpen] = useState(false);
  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const [showSticker, setShowSticker] = useState(false);

  const handleEmailPopup = () => {
    setEmailPopupOpen(v => !v);
  };

  const convertToPST = dateString => {
    const date = new Date(dateString);
    const options = {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    };
    const formatter = new Intl.DateTimeFormat("en-US", options);

    const [
      { value: month },
      ,
      { value: day },
      ,
      { value: year }
    ] = formatter.formatToParts(date);
    return `${year}-${month}-${day}`;
  };

  const delay = () => {
    setTimeout(() => {
      setTrichomeOpen(true);
    }, 8000);
  };

  // Getting the date and converting into PST and comparing
  useEffect(() => {
    const today = new Date();
    const date = convertToPST(today);
    const stickerDate = currentPost?.stickerSchedule?.stickerDate;

    if (
      currentPost?.slug === "cannabis-420-scavenger-hunt" ||
      stickerDate === date
    ) {
      setShowSticker(true);
    }
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const textStickerContainers = document.querySelectorAll(
        ".textStickerContainer"
      );

      if (textStickerContainers.length > 0) {
        textStickerContainers.forEach(container => {
          container.onclick = handleEmailPopup;
        });
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (paxSlugs.includes(window.location.pathname)) {
      includePAXScript();
    }
    scriptCreate();
    // aggleScript();
    delay();
  }, []);

  useEffect(() => {
    if (!isBrowser || !window.location.hash) return;

    const anchorId = decodeURIComponent(window.location.hash.replace(/^#/, ""));
    if (!anchorId) return;

    // Ensure ad deep links land below sticky headers and fire one arrival event.
    const scrollToAnchor = () => {
      const targetElement = document.getElementById(anchorId);
      if (!targetElement) return false;

      const offset = window.innerWidth <= 768 ? 96 : 120;
      const anchorTop =
        targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: Math.max(anchorTop, 0),
        behavior: "auto"
      });

      track("Ad Anchor Landing", {
        anchorId,
        articleSlug: currentPost?.slug,
        templateType: "herb-discover-article"
      });

      return true;
    };

    if (scrollToAnchor()) return;

    const timeoutId = window.setTimeout(() => {
      scrollToAnchor();
    }, 800);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [currentPost?.slug]);

  function scriptCreate() {
    if (isBrowser) {
      setTimeout(() => {
        const script = document.createElement("script");
        script.src = "https://e.infogram.com/js/dist/embed-loader-min.js";
        script.async = true;
        const scriptFunction = document.createElement("script");
        scriptFunction.innerHTML = `
      !function(e,i,n,s){var t="InfogramEmbeds",d=e.getElementsByTagName("script")[0];if(window[t]&&window[t].initialized)window[t].process&&window[t].process();else if(!e.getElementById(n)){var o=e.createElement("script");o.async=1,o.id=n,o.src="https://e.infogram.com/js/dist/embed-loader-min.js",d.parentNode.insertBefore(o,d)}}(document,0,"infogram-async");`;
        document.body.appendChild(script);
        document.body.appendChild(scriptFunction);
      }, 500);
    }
  }

  const trichomeToggle = () => {
    setTrichomeOpen(!trichomeOpen);
  };

  const customStylesPopUp = {
    overlay: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    content: {
      position: "relative",
      background: "rgb(255, 255, 255)",
      maxWidth: "700px",
      overflow: "hidden",
      padding: "0",
      border: "none",
      borderRadius: "0",
      height: "350px",
      width: "100%",
      inset: "0",
      maxHeight: "350px",
      margin: "10px"
    }
  };

  const postSchema = {
    "@context": "http://schema.org",
    "@type": "Article",
    mainEntityOfPage: `${deployUrl}/${categoryPath(currentPost.categories)}/${
      (currentPost || {}).slug
    }/`,
    headline: currentPost.title,
    datePublished: currentPost.ISODate,
    dateModified: currentPost.ISOModified,
    author: {
      "@type": "Person",
      name: currentPost.author.node.name,
      url: `${deployUrl}/authors/${(currentPost.author.node || {}).slug}/`
    },
    description:
      currentPost?.contentSeo?.seo?.metaDescription ||
      currentPost.content_post.postExcerpt,
    image: {
      "@type": "ImageObject",
      url: ((currentPost.featuredImage || {}).node || {}).sourceUrl
    },
    publisher: {
      "@type": "Organization",
      name: "Herb",
      logo: {
        "@type": "ImageObject",
        url: `${deployUrl}/icons/icon-512x512.png`
      }
    }
  };

  let webpageSchema = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    "@id": "#webpage",
    author: {
      "@type": "Organization",
      name: "Herb",
      logo: LOGO_URL
    }
  };

  if ((currentPost.acf || {}).reviewed_by) {
    webpageSchema.reviewedBy = {
      "@type": "Person",
      name: ReactHtmlParser(currentPost.acf.reviewed_by.display_name)[0],
      jobTitle: "Doctor"
    };
  }

  // Generate FAQ Schema dynamically from article content
  const faqItems = [];

  // Extract FAQ data from content
  if (currentPost?.content_post?.content) {
    currentPost.content_post.content.forEach(item => {
      if (
        item.__typename === "WordpressWpPost_ContentPost_Content_Faq" &&
        item.faq &&
        Array.isArray(item.faq)
      ) {
        item.faq.forEach(faqItem => {
          if (faqItem.question && faqItem.answer) {
            faqItems.push({
              "@type": "Question",
              name: faqItem.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faqItem.answer.replace(/<[^>]*>/g, "") // Strip HTML tags from answer
              }
            });
          }
        });
      }
    });
  }

  // Only create FAQ schema if there are FAQ items
  const faqSchema =
    faqItems.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqItems
        }
      : null;

  const breadcrumbs = [
    {
      name: catName,
      url: `/${catSlug}`
    },
    {
      name: currentPost.title,
      url: `/${categoryPath(currentPost.categories)}/${
        (currentPost || {}).slug
      }/`
    }
  ];

  // const { location, loading } = useContext(LocationContext);

  const categories =
    typeof currentPost.categories === Array
      ? currentPost.categories
      : currentPost.categories.nodes;

  const totalLevel1Headings = useMemo(() => {
    const content = currentPost?.content_post?.content || [];
    return content.filter(
      item =>
        item.__typename === "WordpressWpPost_ContentPost_Content_Heading" &&
        item.level === "level1"
    ).length;
  }, [currentPost?.content_post?.content]);

  let headingIdCounter = 0; // Shared by heading ids and ToC ids
  let faqSectionCounter = 0; // Shared by FAQ section ids and ToC ids
  const slugifyAnchorPart = value =>
    String(value || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  // Keep IDs deterministic and collision-safe for repeated modules.
  const anchorIdCounts = {};

  const ensureUniqueAnchorId = baseId => {
    if (!baseId) return null;
    const nextCount = (anchorIdCounts[baseId] || 0) + 1;
    anchorIdCounts[baseId] = nextCount;
    return nextCount === 1 ? baseId : `${baseId}-${nextCount}`;
  };

  const getModuleAnchorId = (item, index) => {
    // Prefer stable CMS keys (databaseId/slug), then fallback to index.
    if (
      item.__typename === "WordpressWpPost_ContentPost_Content_Products" &&
      item.product
    ) {
      const stableKey =
        item.product.databaseId ||
        slugifyAnchorPart(item.product.slug) ||
        slugifyAnchorPart(item.product.title) ||
        index;
      return ensureUniqueAnchorId(`product-${stableKey}`);
    }

    if (item.__typename === "WordpressWpPost_ContentPost_Content_ExternalProduct") {
      const stableKey =
        slugifyAnchorPart(item.title) || slugifyAnchorPart(item.url) || index;
      return ensureUniqueAnchorId(`external-product-${stableKey}`);
    }

    if (item.__typename === "WordpressWpPost_ContentPost_Content_TopPick") {
      const stableKey =
        item.topPickProduct?.databaseId ||
        slugifyAnchorPart(item.topPickProduct?.slug) ||
        slugifyAnchorPart(item.topPickProduct?.title) ||
        index;
      return ensureUniqueAnchorId(`top-pick-${stableKey}`);
    }

    if (
      item.__typename === "WordpressWpPost_ContentPost_Content_CustomTable"
    ) {
      return ensureUniqueAnchorId(`custom-table-${index}`);
    }

    return null;
  };

  var AdShown = false;

  var brandsShown = false;

  const {
    categories: { nodes: category }
  } = currentPost;

  function showAd(index) {
    const lengthOfContent = currentPost.content_post.content.length;

    if (
      !displayAdsToHide.includes((currentPost || {}).slug) &&
      // lengthOfContent > 2 &&
      index % 2 !== 0 &&
      !AdShown &&
      index >= Math.round(lengthOfContent / 2)
    ) {
      AdShown = true;

      return (
        <DisplayAd
          adUnit="21810472093/Learn//Article"
          slotId="div-gpt-ad-1631118969165-0"
          visibleProps={{
            margin: "30px 0px"
          }}
          banners={[
            {
              breakpoint: "mobile",
              sizes: [
                [300, 50],
                [320, 50]
              ]
            },
            {
              breakpoint: "tablet",
              sizes: [
                [320, 50],
                [728, 90]
              ]
            },
            {
              breakpoint: "desktop",
              sizes: [[728, 90]]
            }
          ]}
        />
      );
    }
  }

  function showBrands(index) {
    const lengthOfContent = currentPost.content_post.content.length;
    const middlePoint = Math.round(lengthOfContent / 2);

    if (index >= middlePoint) {
      if (!brandsShown) {
        for (let i = middlePoint; i < lengthOfContent; i++) {
          if (
            currentPost.content_post.content[i]?.__typename ===
            "WordpressWpPost_ContentPost_Content_Heading"
          ) {
            brandsShown = true;

            return <LoadRandomBrands />;
          } else if (
            currentPost.content_post.content[i + 1]?.__typename ===
            "WordpressWpPost_ContentPost_Content_Heading"
          ) {
            brandsShown = true;

            return <LoadRandomBrands />;
          }
          if (brandsShown) {
            break;
          }
        }
      }
    }
  }
  const nextArticletoShow =
    sameCatArticle[generateRandom(0, sameCatArticle.length - 1)];

  return (
    <Layout path={catPath}>
      <>
        {noindex ? (
          <Helmet>
            <meta name="robots" content="noindex" />
          </Helmet>
        ) : (
          <></>
        )}
      </>
      <SEO
        title={currentPost?.contentSeo?.seo?.title || currentPost.title}
        shareTitle={currentPost?.contentSeo?.seo?.shareTitle}
        description={
          currentPost?.contentSeo?.seo?.metaDescription ||
          currentPost.content_post.postExcerpt
        }
        image={((currentPost.featuredImage || {}).node || {}).sourceUrl}
        url={`/${categoryPath(currentPost.categories)}/${
          (currentPost || {}).slug
        }`}
        canonical={`${deployUrl}/${categoryPath(currentPost.categories)}/${
          (currentPost || {}).slug
        }`}
        breadcrumbs={breadcrumbs}
      />
      <JsonLd data={webpageSchema} />
      <JsonLd data={postSchema} />
      {faqSchema && <JsonLd data={faqSchema} />}
      {emailPopupOpen && (
        <ScavengerHuntPopUp
          handleEmailPopup={handleEmailPopup}
          articleSlug={(currentPost || {}).slug}
        />
      )}
      {/* <div className="aticleBreadcrumb">
        <div className="readNow">
          <Link
            className="readLink"
            to={`/${categoryPath(currentPost.categories)}/${
              (currentPost || {}).slug
            }`}
          >
            <p className="nameOfArticle">
              <span className="readingLink">Now Reading:</span>
              {parentCategory(currentPost.categories)?.name} |{" "}
              {ReactHtmlParser(currentPost.title)}
            </p>
          </Link>
        </div>
        <div className="socialLinks">
          <p className="shareLinks">Share:</p>
          <ShareLinks
            url={`/${categoryPath(currentPost.categories)}/${
              (currentPost || {}).slug
            }/`}
            article={currentPost}
            media={
              (currentPost || {}).featuredImage
                ? ((currentPost.featuredImage || {}).node || {}).sourceUrl
                : ""
            }
          />
        </div>
        {nextArticletoShow && (
          <div className="readNext">
            <Link
              className="readLink"
              to={`/${getCategoryPath((nextArticletoShow || {}).categories)}/${
                (nextArticletoShow || {}).slug
              }`}
            >
              <p className="nameOfArticle">
                <span className="readingLink">Next:</span>
                {
                  parentCategory((nextArticletoShow || {}).categories)?.name
                } | {ReactHtmlParser((nextArticletoShow || {}).title)}
              </p>
            </Link>
          </div>
        )}
      </div> */}
      <div className="aticleContentContainer discoverArticleContainer">
        <AnnoucementBarHempBan />
        {(currentPost?.content_post?.disclaimer?.showDisclaimer || (currentPost?.content_post?.content || []).some(item => item.__typename === "WordpressWpPost_ContentPost_Content_Products" || item.__typename === "WordpressWpPost_ContentPost_Content_ExternalProduct" || item.__typename === "WordpressWpPost_ContentPost_Content_TopPick")) && <Disclaimer type="articles" />}             
        <div className="articlePageBanner discoverArticlePageBanner">
          <div className="articlePageBannerImage">
            <Image
              className="lazyload bannerImage discoverArticleBannerImage"
              src={((currentPost.featuredImage || {}).node || {}).sourceUrl}
              alt={
                ((currentPost.featuredImage || {}).node || {}).altText ||
                currentPost.title
              }
              width={1058}
              height={442}
              imgixParams={{
                fit: "clip"
              }}
            />
            {currentPost?.mainImageSticker?.addSticker && showSticker && (
              <div
                className="mainImageStickerContainer"
                onClick={handleEmailPopup}
              >
                <Image
                  className="lazyload mainImageSticker"
                  src={
                    ((currentPost.mainImageSticker || {}).sticker420 || {})
                      .sourceUrl
                  }
                  alt="420 Scavenger Hunt Sticker"
                  width={150}
                  height={150}
                  imgixParams={{
                    fit: "clip"
                  }}
                />
              </div>
            )}
          </div>
          <div className="articleImageCredits">
            <div className="imageCourtesy">
              {ReactHtmlParser(
                ((currentPost.featuredImage || {}).node || {}).caption
              )}
            </div>
          </div>
          <div className="CategoryAndDateDiv discoverArticleCategoryAndDate">
            <ArticleBreadCrumb
              category={category}
              categories={currentPost.categories}
              // date={(currentPost || {}).ISOModified}
              date={currentPost?.ISODate || currentPost?.ISOModified || ""}
              post={currentPost}
              showDate={false}
              showTitle={false}
              seprator="svg"
            />

            <div className="socialLinks discoverArticleSocialLinks">
              <ShareIcons
                url={`/${categoryPath(currentPost.categories)}/${
                  (currentPost || {}).slug
                }/`}
                article={currentPost}
                media={
                  (currentPost || {}).featuredImage
                    ? ((currentPost.featuredImage || {}).node || {}).sourceUrl
                    : ""
                }
              />
            </div>
          </div>
          <div className="articlePageContent discoverArticleContent">
            <h1 className="articlePageH1">{currentPost.title}</h1>
            <p className="articlePageP">
              {(currentPost.content_post || {}).postExcerpt}
            </p>
            <Link
              to={`/authors/${createSlug(currentPost?.author?.node?.name ? currentPost.author.node.name : "sample")}`}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              <div className="discoverArticleAuthor">
                {currentPost?.author?.node?.name}
              </div>
            </Link>
            <p className="discoverArticleDate">
              {new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit"
              }).format(
                new Date(currentPost?.ISODate || currentPost?.ISOModified || "")
              )}
            </p>
          </div>
        </div>

        <div
          className={`featuredArticlePage discoverArticleFeature ${
            showTableofContents ? "discoverArticleFeatureWithToc" : ""
          }`}
        >
          {showTableofContents && (
            <div className="article-toc-sidebar discover-article-toc-sidebar">
              <ArticleTableOfContents
                content={currentPost.content_post.content || []}
              />
            </div>
          )}
          <div className="featuredContentDiv discoverArticleFeatureContent">
            {((currentPost.content_post || {}).content || []).map(
              (item, index) => {
                if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_Image"
                )
                  return (
                    <>
                      <ImageForArticlePage
                        item={item}
                        postTitle={currentPost.title}
                        key={`${item.__typename}-${index}`}
                      />
                      {showAd(index)}
                    </>
                  );
                if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_ExternalProduct"
                )
                  {
                    const externalProductAnchorId = getModuleAnchorId(item, index);

                  return (
                    <div
                      className="copy-link-target"
                      id={externalProductAnchorId || undefined}
                      key={`${item.__typename}-${index}`}
                      style={{ position: "relative" }}
                    >
                      <ArticleProduct
                        item={item}
                      />
                      <CopyLinkButton anchorId={externalProductAnchorId} />
                      {showAd(index)}
                    </div>
                  );
                  }
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_Quote"
                )
                  return (
                    <>
                      <BoldTextForArticlePage
                        item={item}
                        key={`${item.__typename}-${index}`}
                      />
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename === "WordpressWpPost_ContentPost_Content_Text"
                )
                  return (
                    <>
                      <DescriptionForArticlePage
                        item={item}
                        showSticker={showSticker}
                        key={`${item.__typename}-${index}`}
                      />
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename ===
                    "WordpressWpPost_ContentPost_Content_Products" &&
                  item.product
                )
                  {
                    const productAnchorId = getModuleAnchorId(item, index);

                  return (
                    <>
                      {item.product.databaseId !== null &&
                      !isHiddenFromSite(item.product) ? (
                        <div
                          className="copy-link-target"
                          id={productAnchorId || undefined}
                          key={`${item.__typename}-${index}`}
                          style={{ position: "relative" }}
                        >
                          <div className="articlePageProducts">
                            <ProductCard
                              productdetails={item.product}
                              articlePage={true}
                            />
                            <CopyLinkButton anchorId={productAnchorId} />
                          </div>
                          {showAd(index)}
                        </div>
                      ) : null}
                    </>
                  );
                  }
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_Button"
                )
                  return (
                    <>
                      <Button
                        key={`${item.__typename}-${index}`}
                        role="link"
                        to={item.url}
                      >
                        {item.text}
                      </Button>
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_InstagramEmbed"
                )
                  return (
                    <>
                      <PostInstagram
                        key={`${item.__typename}-${index}`}
                        instagram_id={item.instagramId}
                      />
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_YoutubeEmbed"
                )
                  return (
                    <>
                      <PostVideo
                        key={`${item.__typename}-${index}`}
                        type="youtube"
                        video_id={item.videoId}
                      />
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_TwitterEmbed"
                )
                  return (
                    <>
                      <PostTweet
                        key={`${item.__typename}-${index}`}
                        tweet={item.tweetId}
                      />
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_Iframe"
                )
                  return (
                    <>
                      <PostIframe
                        key={`${item.__typename}-${index}`}
                        html={item.iframe}
                      />
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_HerbVideo"
                )
                  return (
                    <>
                      <PostVideo
                        key={`${item.__typename}-${index}`}
                        type="herb"
                        video_id={item.videoId}
                      />
                      {showAd(index)}
                    </>
                  );
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_Heading"
                )
                  {
                    const headingAnchorId = `heading-${headingIdCounter++}`;

                  return (
                    <div
                      className="copy-link-target"
                      key={`${item.__typename}-${index}`}
                      style={{ position: "relative" }}
                    >
                      {/* {showBrands(index)} */}
                      {item.level === "level1" ? (
                        <div className="headingWithSticker">
                          <h2
                            id={headingAnchorId}
                            className="articleSubHeadings"
                            key={`${item.__typename}-${index}`}
                          >
                            {item.text}
                          </h2>
                          {item?.addSticker && showSticker && (
                            <div
                              className="headingStickerContainer"
                              onClick={handleEmailPopup}
                            >
                              <Image
                                className="lazyload headingSticker"
                                src={item?.sticker420?.sourceUrl}
                                alt="420 Scavenger Hunt Sticker"
                                imgixParams={{
                                  fit: "clip"
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ) : item.level === "level2" ? (
                        <div className="headingWithSticker">
                          {totalLevel1Headings > 0 ? (
                            <h3
                              id={headingAnchorId}
                              className="articleSubHeadingsH3"
                              key={`${item.__typename}-${index}`}
                            >
                              {item.text}
                            </h3>
                          ) : (
                            <h2
                              id={headingAnchorId}
                              className="articleSubHeadings"
                              key={`${item.__typename}-${index}`}
                            >
                              {item.text}
                            </h2>
                          )}

                          {item?.addSticker && showSticker && (
                            <div
                              className="headingStickerContainer"
                              onClick={handleEmailPopup}
                            >
                              <Image
                                className="lazyload headingSticker"
                                src={item?.sticker420?.sourceUrl}
                                alt="420 Scavenger Hunt Sticker"
                                imgixParams={{
                                  fit: "clip"
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="headingWithSticker">
                          {totalLevel1Headings > 0 ? (
                            <h4
                              id={headingAnchorId}
                              className="articleSubHeadingsH4"
                              key={`${item.__typename}-${index}`}
                            >
                              {item.text}
                            </h4>
                          ) : (
                            <h3
                              id={headingAnchorId}
                              className="articleSubHeadingsH3"
                              key={`${item.__typename}-${index}`}
                            >
                              {item.text}
                            </h3>
                          )}

                          {item?.addSticker && showSticker && (
                            <div
                              className="headingStickerContainer"
                              onClick={handleEmailPopup}
                            >
                              <Image
                                className="lazyload headingSticker"
                                src={item?.sticker420?.sourceUrl}
                                alt="420 Scavenger Hunt Sticker"
                                imgixParams={{
                                  fit: "clip"
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      <CopyLinkButton
                        anchorId={headingAnchorId}
                        className="heading-copy-link"
                      />
                      {showAd(index)}
                    </div>
                  );
                  }
                else if (
                  item.__typename ===
                  "WordpressWpPost_ContentPost_Content_TopPick"
                ) {
                  const topPickAnchorId = getModuleAnchorId(item, index);

                  return (
                    <div
                      className="copy-link-target"
                      id={topPickAnchorId || undefined}
                      key={`${item.__typename}-${index}`}
                      style={{ position: "relative" }}
                    >
                      <TopPickCard
                        product={item.topPickProduct}
                        productDescription={item?.productDescription}
                      />
                      <CopyLinkButton anchorId={topPickAnchorId} />
                      {showAd(index)}
                    </div>
                  );
                } else if (
                  item.__typename === "WordpressWpPost_ContentPost_Content_Faq"
                ) {
                  const currentFaqSection = faqSectionCounter++;
                  const faqSectionAnchorId = `faq-section-${currentFaqSection}`;
                  return (
                    <div
                      className="articles-faq"
                      id={faqSectionAnchorId}
                    >
                      <h2 className="articleSubHeadings faqSectionHeading">
                        Frequently Asked Questions
                      </h2>
                      <CopyLinkButton
                        anchorId={faqSectionAnchorId}
                        className="faq-section-copy-link"
                      />
                      {item?.faq?.map((faqItem, faqIndex) => (
                        <FAQAccordion
                          key={faqIndex}
                          id={`faq-${currentFaqSection}-${faqIndex}`}
                          question={faqItem.question}
                          answer={faqItem.answer}
                        />
                      ))}
                    </div>
                  );
                } else if (
                  item.__typename === "WordpressWpPost_ContentPost_Content_CustomTable"
                ) {
                  const customTableAnchorId = getModuleAnchorId(item, index);
                  return (
                    <div
                      className="copy-link-target custom-table_copy-link-target"
                      id={customTableAnchorId || undefined}
                      key={`${item.__typename}-${index}`}
                      style={{ position: "relative" }}
                    >
                        <CustomTable data={item} />
                      <CopyLinkButton anchorId={customTableAnchorId} />
                      {showAd(index)}
                    </div>
                  );
                }
              }
            )}
            <div className="tagsForArticles">
              {currentPost.tags.nodes.map(tag => (
                <CategoryTags tag={tag} key={tag.id} />
              ))}
            </div>
            {/* <div className="shareArticleLinks">
              <ShareLinks
                url={`/${categoryPath(currentPost.categories)}/${
                  (currentPost || {}).slug
                }/`}
                article={currentPost}
                media={
                  (currentPost || {}).featuredImage
                    ? ((currentPost.featuredImage || {}).node || {}).sourceUrl
                    : ""
                }
              />
            </div> */}

            {!displayAdsToHide.includes((currentPost || {}).slug) && (
              <DisplayAd
                visibleProps={{
                  margin: "20px 0px"
                }}
                adUnit="21810472093/Learn//Article"
                slotId="div-gpt-ad-1631118969165-0"
                banners={[
                  {
                    breakpoint: "mobile",
                    sizes: [
                      [300, 50],
                      [320, 50]
                    ]
                  },
                  {
                    breakpoint: "tablet",
                    sizes: [
                      [320, 50],
                      [728, 90]
                    ]
                  },
                  {
                    breakpoint: "desktop",
                    sizes: [[728, 90]]
                  }
                ]}
              />
            )}
          </div>
        </div>
        {/* <LoadRandomProducts /> */}
      </div>
      {currentPost.herbDiscoversArticlePage.featuredProducts &&
        currentPost.herbDiscoversArticlePage.featuredProducts.length > 0 && (
          <FeaturedProducts
            featuredProducts={
              currentPost.herbDiscoversArticlePage.featuredProducts
            }
          />
        )}

      {isBrowser ? (
        ilgmSlugs.includes(window.location.pathname) ? (
          <Modal isOpen={trichomeOpen} style={customStylesPopUp}>
            <div
              className="ArticlePopUPModal"
              style={{
                height: "100%"
              }}
            >
              <div className="referralCloseIcon">
                <Box
                  width={["24px", "", "24px"]}
                  css={{
                    background: "white",
                    borderRadius: "50%"
                  }}
                  onClick={trichomeToggle}
                >
                  <Icon
                    icon="close"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                  />
                </Box>
              </div>
              <TrichomePopUpForm />
            </div>
          </Modal>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}

      <Container>
        {!displayAdsToHide.includes((currentPost || {}).slug) && (
          <DisplayAd
            adUnit="21810472093/Learn//Article"
            slotId="div-gpt-ad-1631118969165-0"
            visibleProps={{
              margin: "120px 0px"
            }}
            banners={[
              {
                breakpoint: "mobile",
                sizes: [
                  [300, 50],
                  [320, 50]
                ]
              },
              {
                breakpoint: "tablet",
                sizes: [
                  [320, 50],
                  [728, 90]
                ]
              },
              {
                breakpoint: "desktop",
                sizes: [[970, 250]]
              }
            ]}
          />
        )}
      </Container>
    </Layout>
  );
};

export default PostTemplate;

export const pageQuery = graphql`
  query($id: String!, $catName: String!) {
    wordpressWpPost(id: { eq: $id }) {
      id
      title
      slug
      status
      databaseId
      herbDiscoversArticlePage {
        herbDiscoversTemplate
        featuredProducts {
          ... on WordpressWpProduct {
            ...Product
          }
        }
      }
      tags {
        nodes {
          id
          slug
          name
        }
      }
      stickerSchedule {
        stickerDate
      }
      categories {
        nodes {
          name
          slug
          databaseId
          wpParent {
            node {
              id
              slug
              name
              wpParent {
                node {
                  id
                  slug
                  name
                  wpParent {
                    node {
                      id
                      slug
                      name
                      wpParent {
                        node {
                          id
                          slug
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      featuredImage {
        node {
          sourceUrl
          altText
          caption
          srcSet
          sizes
        }
      }
      mainImageSticker {
        sticker420 {
          sourceUrl
        }
        addSticker
      }
      contentSeo {
        seo {
          title
          shareTitle
          metaDescription
        }
      }
      date(formatString: "MM,DD,YYYY")
      modified(formatString: "MMMM DD, YYYY")
      ISODate: date
      ISOModified: modified
      author {
        node {
          name
          slug
          contentUser {
            userImage {
              sourceUrl
              altText
            }
          }
        }
      }
      tags {
        nodes {
          name
          slug
        }
      }
      hideRecommendedProducts {
        hide
      }
      content_post {
        postExcerpt
          disclaimer {
            showDisclaimer
          }
        content {
          ... on WordpressWpPost_ContentPost_Content_Heading {
            __typename

            level
            text
            fieldGroupName
            addSticker
            sticker420 {
              sourceUrl
            }
          }
          ... on WordpressWpPost_ContentPost_Content_Text {
            __typename

            text
            addSticker
            sticker420 {
              sourceUrl
            }
          }
          ... on WordpressWpPost_ContentPost_Content_HerbVideo {
            __typename

            videoId
            fieldGroupName
          }
          ... on WordpressWpPost_ContentPost_Content_Image {
            __typename
            imageLink
            image {
              sourceUrl
              altText
              caption
            }
          }
          ... on WordpressWpPost_ContentPost_Content_TwitterEmbed {
            __typename

            tweetId
          }
          ... on WordpressWpPost_ContentPost_Content_YoutubeEmbed {
            __typename

            videoId
          }
          ... on WordpressWpPost_ContentPost_Content_InstagramEmbed {
            __typename

            instagramId
            fieldGroupName
          }
          ... on WordpressWpPost_ContentPost_Content_Quote {
            __typename

            attribution
            text
          }
          ... on WordpressWpPost_ContentPost_Content_Iframe {
            __typename

            iframe
            fieldGroupName
          }
          ... on WordpressWpPost_ContentPost_Content_Products {
            __typename

            productLayout
            fieldGroupName
            product {
              ... on WordpressWpProduct {
                __typename
                ...Product
              }
            }
          }
          ... on WordpressWpPost_ContentPost_Content_ExternalProduct {
            __typename

            brand
            fieldGroupName
            title
            url
            image {
              sourceUrl
              altText
              caption
            }
          }
          ... on WordpressWpPost_ContentPost_Content_GrowingSignup {
            __typename

            fieldGroupName
          }
          ... on WordpressWpPost_ContentPost_Content_NewsletterSignup {
            __typename

            fieldGroupName
            newsletter
            text
            title
          }
          ... on WordpressWpPost_ContentPost_Content_Button {
            __typename

            buttonText
            fieldGroupName
            url
          }
          ... on WordpressWpPost_ContentPost_Content_TopPick {
            __typename
            topPickProduct {
              ... on WordpressWpProduct {
                ...Product
              }
            }
            productDescription
          }
          ... on WordpressWpPost_ContentPost_Content_Faq {
            __typename

            fieldGroupName
            faq {
              question
              answer
            }
          }
          ... on WordpressWpPost_ContentPost_Content_CustomTable {
            __typename
            fieldGroupName
            rows {
              ... on WordpressWpPost_ContentPost_Content_CustomTable_Rows_HeaderRow {
                fieldGroupName
                headerRow {
                  headerCell
                }
              }
              ... on WordpressWpPost_ContentPost_Content_CustomTable_Rows_ContentRow {
                fieldGroupName
                contentRow {
                  contentCell {
                    cellHeading
                    cellHeadingColor
                    cellContent
                  }
                }
              }
            }
          }
        }
      }
      tableOfContents {
        showTableOfContents
      }
    }

    sameCatPosts: allWordpressWpPost(
      filter: {
        categories: { nodes: { elemMatch: { name: { eq: $catName } } } }
        id: { ne: $id }
      }
      limit: 4
    ) {
      nodes {
        ...Post
      }
    }

    newPosts: allWordpressWpPost(
      filter: { id: { ne: $id } }
      sort: { fields: [date], order: DESC }
      limit: 10
    ) {
      nodes {
        ...Post
      }
    }

    site {
      siteMetadata {
        title
      }
    }
  }
`;
